<template>
  <form class="form form-loyalty-signup-terms mb-0" @submit.prevent="postTerms">
 
    <!-- start 9460   -->
    <slide-x-left-transition :duration="400" :delay="300">
        <p v-if="show" style="margin-top: 10px">Przed podpisaniem umowy zapoznaj się z <span @click="downloadFile" class="text-bold"> regulaminem</span>.</p>
        <!-- <ion-button v-if="show"
                  mode="ios"
                  fill=""
                  size="small"
                  @click="downloadFile"
                  class="mt-10">regulaminem {{ selectedBrandName }}</ion-button> -->
      </slide-x-left-transition>
      <!-- start 9460   -->
    <slide-x-left-transition :duration="400" :delay="400">
      <p v-if="show" style="margin-top: 10px">Zaznacz wymagane zgody:</p>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="500">
      <div class="form-group" v-show="show">
        <template v-for="(item,index) in loyalty_terms">
          <div class="input-wrapper">
            <!--v-model not working - value is passed as props 'checked'-->
            <ion-checkbox mode="md"
                          :checked="tempAgreements.length > 0 ? tempAgreements[index].isChecked : false"
                          @input="checked = target.value"
                          @ionChange="handleCheckbox($event, index, item.key, item.value)">
            </ion-checkbox>
            <label class="checkbox-label">{{ item.value }}</label>
          </div>
          <p class="error"
             v-if="errors['agreements.'+ item.key]"
             v-text="errors['agreements.'+ item.key][0]">
          </p>
        </template>
      </div>
    </slide-x-left-transition>

    <div class="form-group">
      <label>Podpis Właściciela:</label>
      <div class="signature">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="clearSign('signatureContractor')"
                    class="btn">Wyczyść
        </ion-button>
        <vue-signature-pad width="100%"
                         height="200px"
                         ref="signatureContractor"
                         saveType="image/png">
        </vue-signature-pad>
      </div>
      <p class="error"
         v-if="errors['contractor_data.sign']"
         v-text="errors['contractor_data.sign'][0]">
      </p>
    </div>

    <div class="form-group">
      <label>Podpis Przedstawiciela:</label>
      <div class="signature">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="clearSign('signatureSales')"
                    class="btn">Wyczyść
        </ion-button>
        <vue-signature-pad width="100%"
                         height="200px"
                         ref="signatureSales"
                         saveType="image/png">
        </vue-signature-pad>
      </div>
      <p class="error"
         v-if="errors['sales_representative_data.sign']"
         v-text="errors['sales_representative_data.sign'][0]">
      </p>
    </div>

    <slide-y-up-transition :duration="500" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goToStep(2)"
                    class="mt-10">Wstecz
        </ion-button>
        <ion-button mode="ios"
                    size="small"
                    @click="postTerms"
                    class="mt-10">Przejdź dalej
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields';
  import VueSignaturePad from 'vue-signature-pad';
  import {mapState} from "vuex";
  import router from "../../../router";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'LoyaltySignupTerms',
    computed: {
      ...mapFields({
        signatureContractorData: 'signupForm.contractor_data.sign',
        signatureSalesData: 'signupForm.sales_representative_data.sign',
        agreements : 'signupForm.agreements'
      }),
      ...mapState({
        errors: state => state.loyalty.errors,
        brands: state => state.loyalty.brands,
        selectedBrandSlug: state => state.loyalty.signupForm.brand,
        loyalty_terms: state => state.global.agreements.loyalty_terms
      }),
      indexOfSelectedBrand(){
        if(!this.brands) return
        // find index of element based on selected slug
        return this.brands.map((item) => {
          return item.slug
        }).indexOf(this.selectedBrandSlug)
      },
      selectedBrandName(){
        if(!this.brands) return
        return this.brands[this.indexOfSelectedBrand].name
      },
      selectedBrandFileUrl(){
        if(!this.brands) return
        return this.brands[this.indexOfSelectedBrand].url_to_legal
      }
    },
    data() {
      return {
        show: false,
        tempAgreements: [] // helper
      }
    },
    mounted(){
      this.show = true
      this.resetAgreements()
    },
    methods: {
      downloadFile(){
        if(!this.brands) return
        let filePath = this.selectedBrandFileUrl
        window.open(filePath, 'download')
      },
      handleCheckbox(event, i, key, value) {
        const checkbox = event.target
        // prepare agreements
        let obj = {
          [key]: value
        }
        // checkbox is set true
        if (checkbox.checked) {
          this.tempAgreements[i].isChecked = true
          // before adding obj to obj
          // check duplicates
          const isDuplicate = this.agreements.hasOwnProperty(obj)
          if(!isDuplicate){
            Object.assign(this.agreements, obj)
          }
        }
        // checkbox is set false
        else{
          this.tempAgreements[i].isChecked = false
          // remove agreement item by key
          // unfortunately delete must be done via vuex mutation(!)
          const key = Object.keys(obj)[0]
          this.$store.commit('loyalty/LOYALTY_REMOVE_AGREEMENT', key)
        }
      },
      resetAgreements(){
        // always reset agreements
        this.tempAgreements = []
        // remove agreement item by key
        this.loyalty_terms.forEach((item) => {
          this.$store.commit('loyalty/LOYALTY_REMOVE_AGREEMENT', item.key)
        })
        // copy global agreements to local halper and unbind two-way
        this.tempAgreements = _.cloneDeep(this.loyalty_terms)
      },
      saveSignatures() {
        let contractor = this.$refs.signatureContractor.saveSignature()
        let sales = this.$refs.signatureSales.saveSignature()
        // remove ".data" object after save
        this.signatureContractorData = contractor.data
        this.signatureSalesData = sales.data
      },
      clearSign(pad) {
        this.$refs[pad].clearSignature()
      },
      goToStep(step){
        this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_CURRENT_STEP', step)
      },
      postTerms(){
        this.saveSignatures() // this MUST happen before request
        setTimeout(() => {
          this.$store.dispatch('loyalty/LOYALTY_CONTRACT_STORE_REQUEST', 4)
        },100)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .signature{
    position: relative;
    .btn{
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }
</style>